import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import 'grapesjs-preset-webpage';
import 'grapesjs-preset-newsletter';
import 'grapesjs/dist/css/grapes.min.css';

import { isSrcBase64 } from './funcitons';
import { GrapesjsReact } from 'grapesjs-react';

const HtmlEditor = forwardRef((props: any, ref: any): any => {
    const [editorState, setEditorState] = useState(null);
    const [images, setImages] = useState([]);

    if (ref) {
        useImperativeHandle(
            ref,
            (): any => ({
                getTemplate: (): any => {
                    // @ts-ignore
                    return editorState ? editorState.runCommand('gjs-get-inlined-html') : null;
                }
            }),
            [editorState]
        );
    }

    const assetsBase64Images = (newEditorState: any) => {
        return newEditorState.AssetManager.getAll().models.filter((item: any) => isSrcBase64(item.attributes.src));
    };

    const removeBase64Images = (newEditorState: any) => {
        // dont clear in first try so while
        while (assetsBase64Images(newEditorState).length > 0) {
            assetsBase64Images(newEditorState).map((item: any) => {
                newEditorState.AssetManager.remove(item);
            });
        }
    };

    const addImages = (newImages: any, newEditorState: any) => {
        const am = newEditorState.AssetManager;
        am?.add([...newImages]);
        // @ts-ignore
        setImages((oldImages) => [...oldImages, ...newImages]);
    };

    const loadImages = async (newEditorState: any) => {
        const newImages = await props.getImages();
        addImages(newImages, newEditorState);
    };

    // set editor state and listeners (images upload)
    const onInit = (newEditorState: any) => {
        // clear all data
        newEditorState.setComponents('');

        // clear assets
        // dont clear in first try so while
        while (newEditorState.AssetManager.getAll().models.length > 0) {
            newEditorState.AssetManager.getAll().models.map((item: any) => {
                newEditorState.AssetManager.remove(item);
            });
        }

        if (!images?.length) {
            loadImages(newEditorState);
        }

        // listeners
        // update images, not working on sengrid
        newEditorState.editor.on('asset:upload:response', (data: any) => {
            props.uploadImages(data.data, (newImages: any) => {
                addImages(newImages, newEditorState);
                removeBase64Images(newEditorState);
            });
        });
        // newEditorState.editor.on('asset:upload:end', (data) => {
        //     removeBase64Images(newEditorState);
        // });

        newEditorState.editor.on('asset:remove', (data: any) => {
            if (data?.attributes?.api_ID) {
                props.removeImage(data?.attributes?.api_ID);
            }
        });

        setEditorState(newEditorState);
    };

    const onDestroy = (data: any) => {
    };

    const getAssetImages = () => {
        // @ts-ignore
        const am = editorState?.AssetManager;
        const allAssets = am?.getAll();
        return allAssets.models;
    };

    // set active template
    useEffect(() => {
        if (editorState && props.html_content) {
            // @ts-ignore
            editorState && editorState.setComponents(props.html_content);
        }
    }, [editorState, props.html_content]);

    return (
        <div>
            <GrapesjsReact
                id='grapesjs-react'
                // @ts-ignore
                plugins={['grapesjs-mjml', 'gjs-preset-webpage', 'gjs-blocks-basic', 'gjs-preset-newsletter']}
                onInit={onInit}
                // onDestroy={onDestroy}
            />
        </div>
    );
});

export default HtmlEditor;
